import { useWindowSize } from 'usehooks-ts';

const useGetBreakPoints = () => {
  const { width } = useWindowSize();
  return {
    isMobile: width < 768,
    isTablet: width >= 768,
    isDesktop: width >= 1024,
    isSmallDesktop: width < 1024,
  };
};

export { useGetBreakPoints };
